module.exports = __webpack_public_path__ + "img/20240523_liyuzhe.7f6a1ca5.jpeg";